import { useEffect, type ReactNode } from "react";
import { useSettings } from "../hooks/useSettings";
import "./theme.css";

export function ThemeProvider({ children }: { children: ReactNode }) {
  const settings = useSettings();
  const theme = settings.data?.theme ?? "system";

  useEffect(() => {
    if (theme === "system") delete document.documentElement.dataset.theme;
    else document.documentElement.dataset.theme = theme;
  }, [theme]);

  return <>{children}</>;
}
